import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Gallery.css";
import { useHrStyles } from "../../Context/HRContext";

const Gallery = () => {
  const hrStyles = useHrStyles();
  const images = [
    {
      src: "/assets/images/management1.jpg",
      alt: "Air Bubbles",
    },
    {
      src: "/assets/images/management2.jpg",
      alt: "Maldives Beach",
    },
    {
      src: "/assets/images/management3.jpg",
      alt: "Corn Field",
    },
    {
      src: "/assets/images/management4.jpg",
      alt: "Nature Landscape",
    },
    {
      src: "/assets/images/management4.jpg",
      alt: "River View",
    },
    {
      src: "/assets/images/management3.jpg",
      alt: "Mountain View",
    },
    {
      src: "/assets/images/management2.jpg",
      alt: "Fiji Beach",
    },
    {
      src: "/assets/images/management1.jpg",
      alt: "Sunset",
    },
  ];

  const [showModal, setShowModal] = useState(false);
  const [modalImage, setModalImage] = useState("");

  const handleModalOpen = (src) => {
    setModalImage(src);
    setShowModal(true);
  };

  const handleModalClose = () => {
    setShowModal(false);
  };

  return (
    <div className="container page-top">
      <div className="row">
        {images.map((image, index) => (
          <div className="col-lg-3 col-md-4 col-sm-6 thumb" key={index}>
            <img
              src={image.src}
              alt={image.alt}
              className="zoom img-fluid"
              onClick={() => handleModalOpen(image.src)}
            />
          </div>
        ))}
      </div>

      {/* Bootstrap Modal for Image Preview */}
      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        style={{ display: showModal ? "block" : "none" }}
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-body">
              <img src={modalImage} alt="Modal Preview" className="img-fluid" />
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleModalClose}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
      <hr style={hrStyles} className="mb-3 mt-2" />
    </div>
  );
};

export default Gallery;
